import { axiosClient } from "./axiosClient";

export interface ListingFilters {
  status?: 'pending' | 'active' | 'sold' | 'exchanged' | 'expired' | 'rejected' | 'removed' | 'draft' | 'inactive' | null;
  listingType?: 'marketplace' | 'exchange';
  cursor?: string | null;
  limit?: number;
}

// Fetch all listings (admin only)
export const fetchListings = async (filters: ListingFilters) => {
  const { data } = await axiosClient.get('/marketplace/listings/admin/all', { params: filters });
  return data;
};

// Approve listing (admin only)
export const approveListing = async (listingId: string) => {
  const { data } = await axiosClient.put(`/marketplace/listings/admin/${listingId}/approve`);
  return data;
};

// Reject listing (admin only)
export const rejectListing = async (listingId: string, reason: string) => {
  const { data } = await axiosClient.put(`/marketplace/listings/admin/${listingId}/reject`, {
    reason,
  });
  return data;
};

// Delete listing (admin only)
export const deleteListing = async (listingId: string, reason: string) => {
  const { data } = await axiosClient.delete(`/marketplace/listings/admin/${listingId}`, {
    data: { reason },
  });
  return data;
};

// Get listing statistics (admin only)
export const getListingStats = async () => {
  const { data } = await axiosClient.get('/marketplace/listings/admin/stats');
  return data;
};
